/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.SearchController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { SearchByCriteriaRequest } from '../models/search-by-criteria-request';
import { SearchByCriteriaResponse } from '../models/search-by-criteria-response';
import { SearchByJudgmentProvisionRequest } from '../models/search-by-judgment-provision-request';
import { SearchByJudgmentProvisionResponse } from '../models/search-by-judgment-provision-response';
import { SearchByRegistrationResponse } from '../models/search-by-registration-response';
import { SearchDetailsResponse } from '../models/search-details-response';

@Injectable()
export class SearchApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public get(registrationNumber: number, spinnerMessage: string = null): Observable<SearchByRegistrationResponse> {
        return this.httpClient.get<SearchByRegistrationResponse>(`/api/search/registration/${registrationNumber}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public searchDetailsByRegistration(registration: number, spinnerMessage: string = null): Observable<SearchDetailsResponse> {
        return this.httpClient.get<SearchDetailsResponse>(`/api/search/registration/details/${registration}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public searchByCriteria(request: SearchByCriteriaRequest, spinnerMessage: string = null): Observable<SearchByCriteriaResponse> {
        return this.httpClient.get<SearchByCriteriaResponse>(`/api/search/criteria`,
        {params: this.createOptions(request, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public searchDetailsByHcp(hcpCode: string, spinnerMessage: string = null): Observable<SearchDetailsResponse> {
        return this.httpClient.get<SearchDetailsResponse>(`/api/search/criteria/details/${encodeURIComponent(hcpCode)}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getJudgmentProvisionList(spinnerMessage: string = null): Observable<void> {
        return this.httpClient.get<void>(`/api/search/judgmentprovisionlist`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


    public searchByJudgmentProvision(request: SearchByJudgmentProvisionRequest, spinnerMessage: string = null): Observable<SearchByJudgmentProvisionResponse> {
        return this.httpClient.post<SearchByJudgmentProvisionResponse>(`/api/search/judgmentprovision`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
